<template>
  <v-dialog v-model="dialog" width="800px">
    <v-card>
      <v-card-title class="mx-3">
        {{ $t("CRUD.chooseInfo", [$consts.shopName()]) }}
        <v-spacer />
        <v-tooltip left>
          <template v-slot:activator="{ on, attrs }">
            <v-icon v-bind="attrs" v-on="on" @click="dialog = false">
              fa-times
            </v-icon>
          </template>
          <span>{{ $t("$vuetify.close") }}</span>
        </v-tooltip>
      </v-card-title>
      <v-divider></v-divider>
      <!-- 搜索行 -->
      <v-row dense class="mx-5">
        <v-col cols="12" sm="12" md="4">
          <v-row dense align="center" class="pa-1">
            <SearcherKeyword
              ref="shopKeyword"
              v-model="shopOptions.keyword"
              @text="shopKeyword = $event"
              :label="$t('Shop.shopsKeyword', [$consts.shopName()])"
            />
          </v-row>
        </v-col>
        <v-col cols="12" sm="12" md="8" align-self="center">
          <v-row dense align="center" class="search-controls">
            <v-tooltip bottom>
              <template v-slot:activator="{ on, attrs }">
                <v-btn
                  v-bind="attrs"
                  v-on="on"
                  small
                  text
                  class="px-0 py-0 caption font-weight-bold grey--text"
                  color="primary"
                  @click.stop="onSearch()"
                >
                  <v-icon small class="pe-1">fa-search</v-icon>
                  {{ $t("Search.search") }}
                </v-btn>
              </template>
              <span>{{ $t("Search.searchTip") }}</span>
            </v-tooltip>
            <v-tooltip bottom>
              <template v-slot:activator="{ on, attrs }">
                <v-btn
                  v-bind="attrs"
                  v-on="on"
                  small
                  text
                  class="caption font-weight-bold grey--text"
                  @click.stop="resetSearch()"
                >
                  <v-icon x-small class="pe-1">fa-trash-alt</v-icon>
                  {{ $t("Search.reset") }}
                </v-btn>
              </template>
              <span>{{ $t("Search.resetTip") }}</span>
            </v-tooltip>
            <v-divider vertical />
            <v-btn
                class="caption font-weight-bold grey--text"
                :class="
                $vuetify.theme.dark ? 'text--lighten-1' : 'text--darken-1'
              "
                small
                text
                @click.stop="$store.commit('toggleSearchPanel')"
            >
              {{ $t("Search.pro") }}
              <v-icon small class="ps-1">{{
                  $store.state.showSearchPanel ? "fa-angle-up" : "fa-angle-down"
                }}</v-icon>
            </v-btn>
            <v-spacer />
          </v-row>
        </v-col>
      </v-row>

      <v-data-table
        :headers="headers"
        :items="shops"
        :loading="loading"
        :options.sync="shopOptions"
        :page.sync="paging.page"
        :server-items-length="paging.count"
        multi-sort
        class="elevation-0 px-6"
        fixed-header
        height="360px"
        :footer-props="$t('$config.footer-props')"
      >
        <template v-slot:header.check>
<!--          <v-checkbox-->
<!--            class="mt-2 mb-n3"-->
<!--            color="primary"-->
<!--            :indeterminate="-->
<!--              shops.find((detail) => detail.check != checkAll) ? true : false-->
<!--            "-->
<!--            v-model="checkAll"-->
<!--          >-->
<!--            <template v-slot:label>-->
<!--              <span class="caption ms-n2">-->
<!--                {{ $t("Role.TemplatePermissionFields.check_all") }}-->
<!--              </span>-->
<!--            </template>-->
<!--          </v-checkbox>-->
          <v-btn
            small
            dark
            text
            color="primary"
            class="mb-n2"
            @click.stop="addShop(shops)"
          >
            {{ $t("AlliancesShops.choose") }}
          </v-btn>
        </template>
        <template v-slot:item.check="{ item }">
          <v-btn
            small
            dark
            text
            color="primary"
            class="mb-n2"
            @click.stop="addShop([item])"
            v-if="!(shopSelectedId.find((id) => id == item.id))"
          >
            <v-icon x-small class="pe-1">fa-plus</v-icon>
          </v-btn>
<!--          <div class="d-flex mt-n2 mb-n3">-->
<!--            <v-checkbox-->
<!--              color="primary"-->
<!--              v-model="item.check"-->
<!--              :true-value="1"-->
<!--              :false-value="0"-->
<!--            >-->
<!--            </v-checkbox>-->
<!--          </div>-->
        </template>
      </v-data-table>

      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn
          color="primary"
          outlined
          @click="dialog = false"
          class="elevation-1"
        >
          {{ $t("$vuetify.close") }}
        </v-btn>
<!--        <v-btn-->
<!--          color="accent"-->
<!--          @click="-->
<!--            $emit(-->
<!--              'confirm',-->
<!--              shops.filter((d) => d.check)-->
<!--            );-->
<!--            dialog = false;-->
<!--          "-->
<!--        >-->
<!--          {{-->
<!--            $t("CRUD.confirmWithChooseCount", [-->
<!--              shops.length ? shops.filter((s) => s.check).length : 0,-->
<!--            ])-->
<!--          }}-->
<!--        </v-btn>-->
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>
<script>
import { mapState } from "vuex";
import i18n from "@/i18n";
import Shops from "@/api/shops";
import SearcherKeyword from "@/components/plugins/SearcherKeyword.vue";

const defaultShopOptions = {
  keyword: ""
}

export default {
  name: "DialogShops",

  components: {SearcherKeyword},

  props: {
    value: Boolean,
    shopSelectedId: Array,
    isShopPsi: Boolean,
  },

  computed: {
    headers() {
      return [
        {
          text: i18n.t("Shop.Fields.shop_code", [this.$consts.shopName()]),
          align: "start",
          sortable: false,
          value: "shop_code",
        },
        {
          text: i18n.t("Shop.Fields.shop_name", [this.$consts.shopName()]),
          align: "start",
          sortable: false,
          value: "shop_name",
        },
        {
          text: i18n.t("Role.DistrictPermissionFields.check_all"),
          align: "center",
          sortable: false,
          value: "check",
          width: "100px",
        },
      ];
    },
    // 使用对象展开运算符将此对象混入到外部对象中
    ...mapState(["loading", "settings"]),
  },

  data: () => ({
    dialog: false,
    showSelected: [],
    shopOptions: {},
    filter: "",
    shopKeyword: "",
    shops: [],
    paging: {},
    checkAll: 0,
  }),

  watch: {
    value: {
      immediate: true, //初始赋值也调用
      handler() {
        this.dialog = this.value;
        if (this.dialog) {
          // 每次打开对话框重置查询
          this.getShopsFromAPI();
        }
      },
    },
    dialog: {
      handler() {
        this.$emit("input", this.dialog);
        if (!this.dialog) this.shops = [];
      },
    },
    checkAll: {
      handler() {
        this.shops = this.shops.map(
          function (detail) {
            detail.check = this.checkAll ? 1 : 0;
            return detail;
          }.bind(this)
        );
      },
    },
    shopOptions: {
      deep: true,
      handler() {
        this.getShopsFromAPI()
      }
    }
  },

  methods: {
    getShopsFromAPI() {
      let postData = {}
      if (this.isShopPsi) {
        postData.psi_enable = 1
      }
      let fieldFilter = [
        "id",
        "shop_code",
        "shop_name",
        "status",
        "company_name"
      ];
      postData = Object.assign(
          {
            fieldFilter: fieldFilter,
            // 仅筛选少许必要字段
          },
          this.shopOptions
      );
      this.checkAll = 0;
      Shops.fetchForSelect(postData).then(
        function (response) {
          if (response.data.status.isOK()) {
            this.shops = response.data.shops
            this.paging = response.data.paging;
          } else if (response.data.error.code.isNoResultSet()) {
            this.shopOptions.page = 1;
          }
        }.bind(this)
      );
    },
    onSearch() {
      this.shopOptions = Object.assign({}, this.shopOptions, {
        keyword: this.shopKeyword,
      });
    },
    resetSearch() {
      this.shopOptions = JSON.parse(JSON.stringify(defaultShopOptions));
      [this.$refs.shopKeyword].forEach((k) => {
        if (k) k.clear();
      });
    },
    addShop(shops) {
      let selectShops = [];
      shops.forEach((shop) => {
        if (!(this.shopSelectedId.find((id) => id == shop.id))) {
          selectShops.push(shop)
        }
      })
      this.$emit('add', selectShops)
    }
  },
};
</script>
